export async function addNotifications(formData) {
  const token = localStorage.getItem('token')
  const url = `${process.env.REACT_APP_API}/v1/api/create/notification`
  const rawResponse = await fetch(url, {
    method: 'Post',
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  })

  const content = await rawResponse.json()
  if (rawResponse.status === 200) {
    return { body: content.body, success: true, message: '' }
  } else {
    return { body: [], success: false, message: content.message }
  }
}

export async function fetchNotifications(queryParams) {
  const queryString = Object.keys(queryParams)
    .map((key) => {
      if (queryParams[key]) {
        return `${key}=${queryParams[key]}`
      }
      return ''
    })
    .filter((value) => value !== '')
    .join('&')
  try {
    const token = localStorage.getItem('token')
    // console.log(queryString)
    const rawResponse = await fetch(
      process.env.REACT_APP_API + `/v1/api/all-notifications/?${queryString}`,
      {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      },
    )
    const content = await rawResponse.json()
    if (rawResponse.status === 200) {
      return { body: content.body, success: true, message: '' }
    } else {
      return { body: [], success: false, message: content.message }
    }
  } catch (e) {
    console.error(e)
    return { data: undefined, success: false, message: 'Somthing went wrong !' }
  }
}











export async function deleteNotification(id) {
  const token = localStorage.getItem('token')
  const rawResponse = await fetch(process.env.REACT_APP_API + `/v1/api/delete/notification/${id}`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  const content = await rawResponse.json()
  if (rawResponse.status === 200) {
    return { body: content.body, success: true, message: '' }
  } else {
    return { body: [], success: false, message: content.message }
  }
}

export async function fetchHomePageNotifications() {
  const token = localStorage.getItem('token')
  const rawResponse = await fetch(
    process.env.REACT_APP_API + `/v1/api/notifications`,
    {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    },
  )
  const content = await rawResponse.json()
  if (rawResponse.status === 200) {
    return { body: content.body, success: true, message: '' }
  } else {
    return { body: [], success: false, message: content.message }
  }
}